define('constants/shellNameEnumerations',[],function () {
    return {
        appEntry: "appEntry",
        empty: "empty",
        frontEnd: "frontEnd",
        gradient: "gradient",
        interiorExtended: "interiorExtended",
        login: "login",
        interior: "interior",
        onboarding: "onboarding"
    };
});

